/**
 * User Form Constants
 * Constants for user form component
 */

import { SelectOption } from "../../../components/form/controlled-select";

export const ROLE_OPTIONS: SelectOption[] = [
  { value: "ADMIN", label: "Администратор" },
  { value: "MULTI_BRANCH_ADMIN", label: "Администратор всех филиалов" },
  { value: "SUPER_ADMIN", label: "Супер администратор" },
];

export const PASSWORD_EDIT_HELP_TEXT =
  "Оставьте поле пустым, если вы не хотите менять пароль";

export const PASSWORD_PLACEHOLDER_EDIT = "Оставьте пустым для сохранения текущего";
export const PASSWORD_PLACEHOLDER_CREATE = "Введите пароль";

export const CONFIRM_PASSWORD_PLACEHOLDER_EDIT =
  "Оставьте пустым для сохранения текущего";
export const CONFIRM_PASSWORD_PLACEHOLDER_CREATE = "Повторите пароль";

export const BRANCH_SELECT_PLACEHOLDER = "Выберите филиал (опционально)";

